export const apiUrlTableSecurity = 'menu/table-security/';

